// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".loading-spinner{animation:donut-spin 1.2s linear infinite;animation-duration:1.2s!important;border:3px solid #3b3b3b;border-left-color:#fdfdfd;border-radius:50%;box-sizing:border-box;display:inline-block;height:100%;width:100%}@keyframes donut-spin{0%{transform:rotate(0deg)}to{transform:rotate(1turn)}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
